export const getFirstTwoLetters = (payerName: string) => {
  const compact = (payerName || '').replace(/\s+/g, '');
  if (compact.length === 0) return '??';
  if (compact.length === 1) return compact.charAt(0).toUpperCase() + '?';
  return compact.charAt(0).toUpperCase() + compact.charAt(1).toLowerCase();
};
